import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/config';

/**
 * Everything that draws a workflow step, refreshed after a step mutation and
 * on every step websocket event. `tasks.all` is the prefix of the worker's
 * lists, the task detail, the "Za dodelu" queue, the step calendar and the
 * step attachments; invalidating only some of those left the queue and the
 * calendar showing a step somebody had already taken.
 */
export function invalidateStepQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: queryKeys.tasks.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.shows.all });
  // The open episode page (step list and timeline) reads ['episodes', id].
  queryClient.invalidateQueries({ queryKey: ['episodes'] });
}
